<template>
  <div class="postReadup">
    <Banner :image="post.featured_image"/>
    <PostSummary :post="post"/>
  </div>
</template>

<script>

import Banner from "../components/Banner.vue";
import PostSummary from "../components/PostSummary.vue";
import  { APIService } from "../ApiService.js"

export default {
   components: {
     Banner,
     PostSummary
   },
   data(){
        return {
            fullImageURL:"https://i0.wp.com/truecaller.blog/wp-content/uploads/2021/11/Call-Recording_Blog-Feature-1.png?fit=1200%2C675&ssl=1",
            colorMap:{},
            totalElements:0,
            post: {}
        }
    },
    methods:{
        getPostById(id){
            this.$Loading.start();
            this.$Spin.show();
            var query = "/"+id;
            APIService.get(`posts` + query).then(response => {
                if(response.data){
                    this.post = response.data;
                    this.$Loading.finish();                    
                }
                else{
                    this.$Loading.error();
                }
                this.$Spin.hide();
                console.log(response);
            }); 
        }
    },
    mounted() {
        this.getPostById(this.$route.params.id);
    },
}
</script>
<style scoped>

@media screen and (min-width: 768px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    clip: rect(89px,1400px,709px,0px);
    top: -37px
  }
}
@media only screen and (max-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    top:45px;
  }
}
@media only screen and (min-width: 600px) {
  .headerImage{
    object-fit:initial;
    width: 100%;
    position: relative;
    clip: rect(89px,1400px,709px,0px);
    top: -37px
  }
}
.outerDiv{
  padding: 8px 0px 0px 100px;
}
.innerDiv{  

}
.bannerImage{
  height:100%;
  display: inline-block;
}
.articleHeading{
  font-size: 3vw;
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  color: #504f4f;
}
</style>
